import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import {
  ExpansionPanel,
  ExpansionPanelDetails,
  Grid,
  Typography,
} from '../../../base';

import { permissions } from '../../../../constants/permissions';
import { userHasPermission } from '../../../../utils/permissions';

import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { renderProperDataFormat } from '../constants';

const styles = theme => ({
  container: {
    margin: `${theme.spacing(3)}px 0 0`,
    border: '1px solid #ccc',
    borderRadius: theme.shape.borderRadius,
  },
  headerRowContainer: {
    borderBottom: '1px solid #ccc',
    borderRadius: `${theme.spacing(0.5)}px ${theme.spacing(0.5)}px 0 0`,
    backgroundColor: 'white',
    padding: `${theme.spacing(3)}px ${theme.spacing()}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
  },
  header: {
    textTransform: 'uppercase',
  },
  tableHeader: {
    padding: theme.spacing(),
    background: '#eee',
    display: 'flex',
    alignItems: 'center',
  },
  tableBody: {
    padding: theme.spacing(),
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    background: 'white',
  },
  expansionPanel: {
    paddingLeft: theme.spacing(),
  },
})

const JobMobileView = ({
  styles: s,
  classes: c,
  t,
  gt,
  data,
  columns,
  TagJob,
  JobProgress,
  EditLink,
  lastStatus,
  additionalInfo,
  user,
}) => {

  return (
    <Grid container className={c.container}>
      <Grid item xs={12}
        className={classNames(s.headerRowStyles, c.headerRowContainer)}
      >
        <div className={c.headerRow}>
          {userHasPermission(user, permissions.TAG_INTEREST) ? TagJob : null}
          <span className={classNames(c.header, s.textColor)}>{t.id} {data.id}</span>
        </div>
        {EditLink}
      </Grid>

      <Grid container>
        {columns.map(row => {
          if(row.colName !== 'alerts' && row.data) {
            return (
              <Fragment key={row.colId}>
                <Grid
                  className={classNames(s.tableHeaderText, c.tableHeader)}
                  item xs={5}
                >
                  <Typography variant='caption'>{row.text}</Typography>
                </Grid>
                <Grid
                  className={c.tableBody}
                  item xs={7}
                >
                  {row.data ? renderProperDataFormat(row, data, gt) : ''}
                </Grid>
              </Fragment>
            )
          };
          return null;
        })}
      </Grid>

      <Grid item xs={12}>
        <ExpansionPanel>
          <ExpansionPanelSummary
            className={c.expansionPanel}
            expandIcon={<ExpandMoreIcon/>}
          >
            {gt.Status.title}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={c.expansionPanel}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {lastStatus}
              </Grid>
              <Grid item xs={12}>
                {additionalInfo}
              </Grid>
  {/* Removed for now. Will be re-implemented.
              <Grid item xs={12}>
                {JobProgress}
              </Grid>
  */}
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(JobMobileView);



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/views/JobMobile.js